import { Box, Container, makeStyles, Divider } from '@material-ui/core';
import React from 'react'; // useEffect
import PrivateRoute from '../../auth/Routes/PrivateRoute';
import { Switch } from 'react-router-dom';
import FinanceHeader from './FinanceHeader';
import SideNavBar from './SideNavBar';
import DiscountScreen from './ManagementAppApproval/ManagementAppApproval';
import DiscoveryAppApproval from './DiscoveryAppApproval/DiscoveryAppApproval';
import ConfirmAdmissionScreen from './ConfirmAdmissionScreen/ConfirmAdmissionScreen';
import useToggleSideNav from '../../hooks/useToggleSideNav';
import {
  APPROVAL_DISCOVERY_APP_ROUTE,
  APPROVAL_MGMENT_VIEW_DETAILS_ROUTE,
  APPROVAL_MGMENT_APP_ROUTE,
  FINANCE_MODULE_ROUTE,
  APPROVAL_USER_KYC_ROUTE,
  APPROVAL_STORY_ROUTE,
  SCHOOL_DETAILS_ROUTE,
  APPROVAL_CREATE_STORY_ROUTE,
  APPROVAL_UPDATE_STORY_ROUTE,
} from '../../routes/routes';
import KycApproval from './UserKycApprove/KycApproval';
import StoryApprovalScreen from './StoryApproval/StoryApprovalScreen';
import useScopes from '../../hooks/useScopes';
import { useSelector } from 'react-redux';
import ViewDetails from './ManagementAppApproval/SchoolDetails/ViewDetails';
import { useLocation } from 'react-router-dom/cjs/react-router-dom';
import CreateStory from './StoryApproval/CreateStory';
import UpdateStory from './StoryApproval/UpdateStory';

const useStyles = makeStyles((theme) => ({
  overAll: {
    maxWidth: 1452,
    backgroundColor: theme.palette.buzzContainerColor,
    borderRadius: 4,
    padding: 44,
    paddingTop: 24,
    minHeight: '100vh',
    display: 'flex',
    flexDirection: 'column',
    marginBottom: 60,
    fontFamily: 'Rubik',
  },
  underLine: {
    textDecoration: 'underline',
    cursor: 'pointer',
  },
  pointer: { cursor: 'pointer' },
}));

const DoNotHaveAccess = () => {
  return (
    <Box
      fontFamily={'Rubik'}
      width={'100%'}
      minHeight={400}
      display="flex"
      justifyContent={'center'}
      alignItems="center">
      <Box maxWidth={500} fontSize={16} textAlign={'center'}>
        <Box mb={1}>You do not have access to this feature</Box>
        <Box fontSize={12}>
          NOTE: You are seeing this screen because you did not complete your KYC
          or you do not have permission to view this screen or You are not a
          PLATINUM member
        </Box>
      </Box>
    </Box>
  );
};

const Finances = () => {
  const classes = useStyles();
  const { access } = useScopes();
  const { show } = useToggleSideNav();
  const location = useLocation();

  const { moduleAccess } = useSelector(({ signInReducer }) => {
    return {
      moduleAccess: signInReducer.me
        ? signInReducer.me.data
          ? signInReducer.me.data.role
          : []
        : [],
    };
  });

  return (
    <Container className={classes.overAll}>
      {location.pathname === '/approval-management/view-details' ? null : (
        <Box mb={4}>
          <FinanceHeader />
          <Divider />
        </Box>
      )}
      <Box display="flex" flex={7}>
        {location.pathname === '/approval-management/view-details' ||
        location.pathname === '/approval-management/create-story' ||
        location.pathname === '/approval-management/update-story' ? null : (
          <>{show && <SideNavBar />}</>
        )}
        <Box flex={8}>
          <Switch>
            <PrivateRoute
              exact
              path={[APPROVAL_MGMENT_APP_ROUTE, FINANCE_MODULE_ROUTE]}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['approval:management:readWrite'],
                })
                  ? DiscountScreen
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              exact
              path={APPROVAL_DISCOVERY_APP_ROUTE}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['approval:discovery:readWrite'],
                })
                  ? DiscoveryAppApproval
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              path={APPROVAL_MGMENT_VIEW_DETAILS_ROUTE}
              component={ConfirmAdmissionScreen}
            />
            <PrivateRoute
              path={APPROVAL_USER_KYC_ROUTE}
              // component={UserKycApprove}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['approval:kyc:readWrite'],
                })
                  ? KycApproval
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              exact
              path={APPROVAL_STORY_ROUTE}
              component={
                moduleAccess.includes('bccSuperAdmin') ||
                access({
                  mode: 'allOf',
                  scope: ['approval:story:readWrite'],
                })
                  ? StoryApprovalScreen
                  : DoNotHaveAccess
              }
            />
            <PrivateRoute
              exact
              path={SCHOOL_DETAILS_ROUTE}
              component={ViewDetails}
            />
            <PrivateRoute
              exact
              path={APPROVAL_CREATE_STORY_ROUTE}
              component={CreateStory}
            />
            <PrivateRoute
              exact
              path={APPROVAL_UPDATE_STORY_ROUTE}
              component={UpdateStory}
            />
          </Switch>
        </Box>
      </Box>
    </Container>
  );
};

export default Finances;
